import React from "react";
import { Row, Col } from "reactstrap";
import InfoIcon from "../../Assets/external_icons/color/info1.png";
import TotalEnergyIcon from "../../Assets/external_icons/color/energy.png";
import CO2Icon from "../../Assets/external_icons/color/co2.png";
import TempIcon from "../../Assets/external_icons/color/hot.png";
import Widget02 from "../../Components/Widgets/Widget02";

const Main_Widget = () => {

  return (
    <Row>
      <Col xs="12" sm="6" lg="3">
        <Widget02
          className="small-widget"
          style={{ borderRadius: "4px" }}
          header="تعداد نیروگاه ها"
          mainText=""
          icon={<img style={{ width: "40px" }} src={InfoIcon} />}
          color="primary"
          variant="1"
        />
      </Col>
      <Col xs="12" sm="6" lg="3">
        <Widget02
          className="small-widget"
          header="تعداد مشترکین"
          mainText=""
          icon={<img style={{ width: "40px" }} src={TotalEnergyIcon} />}
          color="danger"
          variant="1"
          style={{ direction: "ltr" }}
        />
      </Col>
      <Col xs="12" sm="6" lg="3">
        <Widget02
          className="small-widget"
          header="تعداد تیکت ها"
          mainText=""
          icon={<img style={{ width: "40px" }} src={CO2Icon} />}
          color="dark"
          variant="1"
          style={{ direction: "ltr" }}
        />
      </Col>
      <Col xs="12" sm="6" lg="3">
        <Widget02
          className="small-widget"
          header="درآمد کل"
          mainText=""
          icon={<img style={{ width: "40px" }} src={TempIcon} />}
          color="info"
          variant="1"
          style={{ direction: "ltr" }}
        />
      </Col>
    </Row>
  );
};

export default Main_Widget;
